import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { EmailTemplatesPage } from "@/components/app/email-templates";

const description =
  "Manage the saved email templates you and your team reuse across outreach.";

export const Route = createFileRoute("/_authenticated/t1dwpanel/email-templates")({
  head: () => ({
    meta: [
      { title: "Email templates | Warrior Volunteer" },
      { name: "description", content: description },
      { property: "og:title", content: "Email templates | Warrior Volunteer" },
      { property: "og:description", content: description },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: EmailTemplatesRoute,
});

function EmailTemplatesRoute() {
  return (
    <AppShell eyebrow="Admin" title="Email templates">
      <EmailTemplatesPage />
    </AppShell>
  );
}
